<div class="form-container" [formGroup]="firstFormGroup" *ngIf="popupType == 1">
    <!-- Header -->
    <div class="header-row">
        <div class="header-text">
            Update Lead
        </div>
        <div>
            <mat-icon (click)="callclosepopup()" style="cursor:pointer; color: white;">close</mat-icon>
        </div>
    </div>

    <!-- Scrollable Body -->
    <div class="form-scroll-body">
        <!-- Name -->
        <mat-form-field appearance="outline" class="premium-field">
            <mat-label>Name</mat-label>
            <mat-icon matPrefix class="prefix-icon">star_border</mat-icon>
            <input [attr.guide]="'popup-leadstatus-inp-name-1' + '__' + sanitizeUrl(url)" matInput formControlName="Name"
                [placeholder]="editModeName ? 'Enter Name' : LeadDetailsObject?.name"/>
        </mat-form-field>

        <!-- Phone Number -->
        <mat-form-field appearance="outline" class="premium-field">
            <mat-label>Phone Number</mat-label>
            <mat-icon matPrefix class="prefix-icon">call</mat-icon>
            <input [attr.guide]="'popup-leadstatus-inp-phonenumber-1' + '__' + sanitizeUrl(url)" matInput formControlName="PhoneNumber"
                [placeholder]="editModePhoneNumber ? 'Enter Phone Number' : LeadDetailsObject?.phoneNumber"/>
        </mat-form-field>

        <!-- Secondary Phone Number -->
        <mat-form-field appearance="outline" class="premium-field">
            <mat-label>Secondary Phone Number</mat-label>
            <mat-icon matPrefix class="prefix-icon">call</mat-icon>
            <input [attr.guide]="'popup-leadstatus-inp-secondaryphoneno-1' + '__' + sanitizeUrl(url)" matInput formControlName="secondaryphoneno"
                [placeholder]="editModePhoneNumber ? 'Enter Phone Number' : LeadDetailsObject?.secondaryphoneno"/>
        </mat-form-field>

        <!-- Lead Status -->
        <mat-form-field appearance="outline" class="premium-field my-custom-field">
            <mat-label class="white-text">Lead Status</mat-label>
            <mat-icon matPrefix class="prefix-icon">thumbs_up_down</mat-icon>
            <mat-select class="white-text" formControlName="LeadStatus" [disableOptionCentering]="true"
                #singleSelect autocomplete="off">
                <mat-option>
                    <ngx-mat-select-search name="Lead Status Search" ngDefaultControl
                        [formControl]="typeYFilterControl" placeholderLabel="Lead Status Search"
                        [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option class="white-text"
                    (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId,opt.statusId, opt.statusName, opt)"
                    *ngFor="let opt of filtereddropdownTypeList; let i=index;" [value]="opt.statusId">
                    {{opt.statusName}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Dynamic Form -->
        <div *ngIf="formInit" style="width: 100%;">
            <simple-dynamic-form [layout]="2" [formValue]="patchValues"
                [status]="firstFormGroup.value.LeadStatus" [type]="2" (submit)="onFormSubmitted($event)"
                [fields]="regConfig">
            </simple-dynamic-form>
        </div>

        <!-- Remarks -->
        <mat-form-field appearance="outline" class="premium-field">
            <mat-label>Remarks</mat-label>
            <mat-icon matPrefix class="prefix-icon">note</mat-icon>
            <textarea [attr.guide]="'popup-leadstatus-sel-remarks-1' + '__' + sanitizeUrl(url)" trim="blur" matTextareaAutosize matAutosizeMinRows=2 matAutosizeMaxRows=5 matInput
                formControlName="remarks"></textarea>
        </mat-form-field>

        <!-- Follow up Date & Time -->
        <div fxLayout="row" fxLayoutGap="12px" style="gap: 12px; width: 100%;" *ngIf="scheduleNextAction != 0">
            <mat-form-field fxFlex="50" appearance="outline" class="premium-field">
                <mat-label>Follow up Date</mat-label>
                <mat-icon matPrefix class="prefix-icon">event</mat-icon>
                <input [attr.guide]="'popup-leadstatus-inp-followupdatetime-1' + '__' + sanitizeUrl(url)" required [min]="minDate" [matDatepicker]="followUp" formControlName="followUpDate" matInput/>
                <mat-datepicker-toggle [for]="followUp" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #followUp></mat-datepicker>
                <mat-error *ngIf="firstFormGroup.get('followUpDate')?.hasError('required')">
                    Please fill out this field.
                </mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="50" appearance="outline" class="premium-field">
                <mat-label>Follow up Time</mat-label>
                <mat-icon matPrefix class="prefix-icon">access_time</mat-icon>
                <input [attr.guide]="'popup-leadstatus-inp-followuptime-1' + '__' + sanitizeUrl(url)" type="time" formControlName="followUpTime" matInput/>
            </mat-form-field>
        </div>
    </div>

    <!-- Footer Section -->
    <div class="footer-container">
        <div class="footer-row">
            <button [attr.guide]="'popup-leadstatus-btn-2-1' + '__' + sanitizeUrl(url)" color="primary" (click)="checkLeadExist()" class="savechanges"
                [disabled]="textSave != 'Save'" mat-raised-button>
                {{ textSave }}
                <mat-icon *ngIf="textSave != 'Save'">
                    <mat-spinner color="primary" diameter="20"> </mat-spinner>
                </mat-icon>
            </button>
            <button [attr.guide]="'popup-leadstatus-btn-3-1' + '__' + sanitizeUrl(url)" mat-raised-button color="accent" (click)="callclosepopup()"
                class="closebutton">Close</button>
        </div>
    </div>
</div>

<div class="form-container" [formGroup]="firstFormGroup" *ngIf="popupType == 2">
    <!-- Header -->
    <div class="header-row">
        <div class="header-text">
            Mark as Priority
        </div>
        <div>
            <mat-icon (click)="callclosepopup()" style="cursor:pointer; color: white;">close</mat-icon>
        </div>
    </div>

    <div class="form-scroll-body" style="align-items: center;">
        <div class="priority-container" style="width: 100%;">
            <h2 style="margin-top: 0;">Select Priority</h2>
            <div fxLayout="column" class="radio-row" style="margin: 20px 0;">
                <mat-radio-group formControlName="priority">
                    <mat-radio-button [attr.guide]="'popup-leadstatus-chk-4-1' + '__' + sanitizeUrl(url)" class="radio-option" *ngFor="let priority of priorities;let i =index"
                        [value]="priority" (click)="updatePriority(i)" style="margin: 10px 0; display: block;">
                        {{ priority }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="submit-section" style="width: 100%;">
                <button [attr.guide]="'popup-leadstatus-btn-6-1' + '__' + sanitizeUrl(url)" color="primary" (click)="submitone()" class="savechanges" [disabled]="text != 'Submit'"
                    mat-raised-button style="width: 100%;">
                    {{ text }}
                    <mat-icon *ngIf="text != 'Submit'">
                        <mat-spinner color="primary" diameter="20"> </mat-spinner>
                    </mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="form-container" [formGroup]="firstFormGroup" *ngIf="popupType == 3">
    <!-- Header -->
    <div class="header-row">
        <div class="header-text">
            Update Lead Stage
        </div>
        <div>
            <mat-icon (click)="callclosepopup()" style="cursor:pointer; color: white;">close</mat-icon>
        </div>
    </div>

    <div class="form-scroll-body">
        <mat-form-field appearance="outline" class="premium-field my-custom-field">
            <mat-label class="white-text">Lead Status</mat-label>
            <mat-icon matPrefix class="prefix-icon">thumbs_up_down</mat-icon>
            <mat-select class="white-text" formControlName="LeadStatus" [disableOptionCentering]="true"
                #singleSelect autocomplete="off">
                <mat-option>
                    <ngx-mat-select-search name="Lead Status Search" ngDefaultControl
                        [formControl]="typeYFilterControl" placeholderLabel="Lead Status Search"
                        [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option class="white-text"
                    (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId,opt.statusId, opt.statusName)"
                    *ngFor="let opt of filtereddropdownTypeList; let i=index;" [value]="opt.statusId">
                    {{opt.statusName}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div *ngIf="formInit" style="width: 100%;">
            <simple-dynamic-form [layout]="2" [formValue]="patchValues"
                [status]="firstFormGroup.value.LeadStatus" [type]="2" (submit)="onFormSubmitted($event)"
                [fields]="regConfig">
            </simple-dynamic-form>
        </div>
    </div>

    <!-- Footer Section -->
    <div class="footer-container">
        <div class="footer-row">
            <button [attr.guide]="'popup-leadstatus-btn-10-1' + '__' + sanitizeUrl(url)" color="primary" (click)="checkLeadExist()" class="savechanges"
                [disabled]="textSave != 'Save'" mat-raised-button>
                {{ textSave }}
                <mat-icon *ngIf="textSave != 'Save'">
                    <mat-spinner color="primary" diameter="20"> </mat-spinner>
                </mat-icon>
            </button>
            <button [attr.guide]="'popup-leadstatus-btn-11-1' + '__' + sanitizeUrl(url)" mat-raised-button color="accent" (click)="callclosepopup()"
                class="closebutton">Close</button>
        </div>
    </div>
</div>

<div class="form-container" [formGroup]="firstFormGroup" *ngIf="popupType == 4">
    <!-- Header -->
    <div class="header-row">
        <div class="header-text">
            Update Lead
        </div>
        <div>
            <mat-icon (click)="callclosepopup()" style="cursor:pointer; color: white;">close</mat-icon>
        </div>
    </div>

    <div class="form-scroll-body">
        <mat-form-field appearance="outline" class="premium-field">
            <mat-label>Remarks</mat-label>
            <mat-icon matPrefix class="prefix-icon">note</mat-icon>
            <textarea [attr.guide]="'popup-leadstatus-sel-remarks-1' + '__' + sanitizeUrl(url)" trim="blur" matTextareaAutosize matAutosizeMinRows=2 matAutosizeMaxRows=5 matInput
                formControlName="remarks"></textarea>
        </mat-form-field>
    </div>

    <!-- Footer Section -->
    <div class="footer-container">
        <div class="footer-row">
            <button [attr.guide]="'popup-leadstatus-btn-12-1' + '__' + sanitizeUrl(url)" color="primary" (click)="checkLeadExist()" class="savechanges"
                [disabled]="textSave != 'Save'" mat-raised-button>
                {{ textSave }}
                <mat-icon *ngIf="textSave != 'Save'">
                    <mat-spinner color="primary" diameter="20"> </mat-spinner>
                </mat-icon>
            </button>
            <button [attr.guide]="'popup-leadstatus-btn-13-1' + '__' + sanitizeUrl(url)" mat-raised-button color="accent" (click)="callclosepopup()"
                class="closebutton">Close</button>
        </div>
    </div>
</div>

<div class="form-container" [formGroup]="firstFormGroup" *ngIf="popupType == 5">
    <!-- Header -->
    <div class="header-row">
        <div class="header-text">
            Update Lead
        </div>
        <div>
            <mat-icon (click)="callclosepopup()" style="cursor:pointer; color: white;">close</mat-icon>
        </div>
    </div>

    <div class="form-scroll-body">
        <div fxLayout="row" *ngIf="scheduleNextAction != 0" fxLayoutGap="12px" style="gap: 12px; width: 100%;">
            <mat-form-field fxFlex="50" appearance="outline" class="premium-field">
                <mat-label>Follow up Date</mat-label>
                <mat-icon matPrefix class="prefix-icon">event</mat-icon>
                <input [attr.guide]="'popup-leadstatus-inp-followupdatetime-5' + '__' + sanitizeUrl(url)" required [matDatepicker]="followUp5" formControlName="followUpDate" matInput/>
                <mat-datepicker-toggle [for]="followUp5" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #followUp5></mat-datepicker>
                <mat-error *ngIf="firstFormGroup.get('followUpDate')?.hasError('required')">
                    Please fill out this field.
                </mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="50" appearance="outline" class="premium-field">
                <mat-label>Follow up Time</mat-label>
                <mat-icon matPrefix class="prefix-icon">access_time</mat-icon>
                <input [attr.guide]="'popup-leadstatus-inp-followuptime-5' + '__' + sanitizeUrl(url)" type="time" formControlName="followUpTime" matInput/>
            </mat-form-field>
        </div>
    </div>

    <!-- Footer Section -->
    <div class="footer-container">
        <div class="footer-row">
            <button [attr.guide]="'popup-leadstatus-btn-14-1' + '__' + sanitizeUrl(url)" color="primary" (click)="checkLeadExist()" class="savechanges"
                [disabled]="textSave != 'Save'" mat-raised-button>
                {{ textSave }}
                <mat-icon *ngIf="textSave != 'Save'">
                    <mat-spinner color="primary" diameter="20"> </mat-spinner>
                </mat-icon>
            </button>
            <button [attr.guide]="'popup-leadstatus-btn-15-1' + '__' + sanitizeUrl(url)" mat-raised-button color="accent" (click)="callclosepopup()"
                class="closebutton">Close</button>
        </div>
    </div>
</div>

<div class="form-container" [formGroup]="firstFormGroup" *ngIf="popupType == 6">
    <!-- Header -->
    <div class="header-row">
        <div class="header-text">
            Update Lead Notes
        </div>
        <div>
            <mat-icon (click)="callclosepopup()" style="cursor:pointer; color: white;">close</mat-icon>
        </div>
    </div>

    <div class="form-scroll-body">
        <mat-form-field appearance="outline" class="premium-field">
            <mat-label>Notes</mat-label>
            <mat-icon matPrefix class="prefix-icon">note</mat-icon>
            <textarea [attr.guide]="'popup-leadstatus-sel-branch-1' + '__' + sanitizeUrl(url)" trim="blur" matTextareaAutosize matAutosizeMinRows=2 matAutosizeMaxRows=5 matInput
                formControlName="branch"></textarea>
        </mat-form-field>
    </div>

    <!-- Footer Section -->
    <div class="footer-container">
        <div class="footer-row">
            <button [attr.guide]="'popup-leadstatus-btn-16-1' + '__' + sanitizeUrl(url)" color="primary" (click)="checkLeadExist()" class="savechanges"
                [disabled]="textSave != 'Save'" mat-raised-button>
                {{ textSave }}
                <mat-icon *ngIf="textSave != 'Save'">
                    <mat-spinner color="primary" diameter="20"> </mat-spinner>
                </mat-icon>
            </button>
            <button [attr.guide]="'popup-leadstatus-btn-17-1' + '__' + sanitizeUrl(url)" mat-raised-button color="accent" (click)="callclosepopup()"
                class="closebutton">Close</button>
        </div>
    </div>
</div>
